import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import type { Product } from '../types'
import { ConfirmDialog } from '@/shared/components/ui/molecules/ConfirmDialog'

interface ProductListProps {
  products: Product[]
  onDelete: (sku: string) => void
}

export function ProductList({ products, onDelete }: ProductListProps) {
  const [deleteProduct, setDeleteProduct] = useState<Product | null>(null)

  const handleConfirmDelete = () => {
    if (deleteProduct) {
      onDelete(deleteProduct.sku)
      setDeleteProduct(null)
    }
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No hay productos registrados
      </div>
    )
  }

  return (
    <div>
      <div className="space-y-3">
        {products.map((product) => (
          <div
            key={product.sku}
            className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
          >
            <div>
              <h3 className="font-medium text-gray-900">{product.name}</h3>
              <p className="text-sm text-gray-500">SKU: {product.sku}</p>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-sm font-medium text-primary-600">
                {product.points} puntos
              </span>
              <button
                onClick={() => setDeleteProduct(product)}
                className="text-red-500 hover:text-red-700 transition-colors"
                title="Eliminar"
              >
                <Trash2 size={18} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <ConfirmDialog
        isOpen={!!deleteProduct}
        title="Eliminar Producto"
        message={deleteProduct ? `Desea eliminar el producto ${deleteProduct.name} (${deleteProduct.sku})?` : ''}
        onConfirm={handleConfirmDelete}
        onCancel={() => setDeleteProduct(null)}
      />
    </div>
  )
}
